/* eslint-disable no-console */
import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { Resource } from "@opentelemetry/resources";
import { BatchSpanProcessor } from "@opentelemetry/sdk-trace-base";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { W3CTraceContextPropagator } from "@opentelemetry/core";
import {
  ATTR_SERVICE_NAME,
  ATTR_SERVICE_VERSION,
} from "@opentelemetry/semantic-conventions";

import {
  G_POS_VERSION,
  OTEL_EXPORTER_OTLP_ENDPOINT,
} from "./constants";

const getTraceEndpoint = (endpoint) => {
  if (!endpoint) return "";
  const normalizedEndpoint = endpoint.replace(/\/$/, "");
  return normalizedEndpoint.endsWith("/v1/traces")
    ? normalizedEndpoint
    : `${normalizedEndpoint}/v1/traces`;
};

export const initTracing = () => {
  try {
    const traceEndpoint = getTraceEndpoint(OTEL_EXPORTER_OTLP_ENDPOINT);
    const provider = new WebTracerProvider({
      spanProcessors: traceEndpoint
        ? [
            new BatchSpanProcessor(
              new OTLPTraceExporter({
                url: traceEndpoint,
                // Buộc exporter dùng XHR thay vì sendBeacon để tránh
                // credentials mode=include với OTEL Gateway CORS wildcard.
                headers: {},
              }),
            ),
          ]
        : [],
      resource: new Resource({
        [ATTR_SERVICE_NAME]: "qr-order",
        [ATTR_SERVICE_VERSION]: G_POS_VERSION || "unknown",
      }),
    });

    provider.register({
      propagator: new W3CTraceContextPropagator(),
    });

  } catch (error) {
    console.error("[tracing] Không thể khởi tạo OpenTelemetry:", error);
  }
};
